const last2Items = -2;
const matchPort = /:\d+/;

export default (hostname: string) => hostname.replace(matchPort, "").split(".").slice(last2Items).join(".");
